module.exports = __webpack_public_path__ + "static/media/kumo-janai.32f32048.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/myaccount/Dashboard/kumo-janai.svg
 ** module id = 475
 ** module chunks = 0
 **/